<div style="width:320px;height:310px;">
  <div *ngIf="isVisible">
    <bs-datepicker-inline [attr.class]="!isVisible?'d-none':null"
                          [bsValue]="bsInlineValue" 
                          (bsValueChange)="onValueChange($event)"
                          [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY', customTodayClass:'custom-today-class'}" 
                          [dateCustomClasses]="selectedClass">
    </bs-datepicker-inline>
  </div>
</div>
